/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_OpeningInputs */

const en_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const fr_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const de_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const it_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const ru_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const es_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const zh_cn2_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const ja_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const hi_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const pt_pt2_explorer_search_opening = /** @type {(inputs: Explorer_Search_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

/**
* | output |
* | --- |
* | "Opening..." |
*
* @param {Explorer_Search_OpeningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_opening = /** @type {((inputs?: Explorer_Search_OpeningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_OpeningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_opening(inputs)
	if (locale === "de") return de_explorer_search_opening(inputs)
	if (locale === "it") return it_explorer_search_opening(inputs)
	if (locale === "ru") return ru_explorer_search_opening(inputs)
	if (locale === "es") return es_explorer_search_opening(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_opening(inputs)
	if (locale === "ja") return ja_explorer_search_opening(inputs)
	if (locale === "hi") return hi_explorer_search_opening(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_opening(inputs)
	return en_explorer_search_opening(inputs)
});